import {tns} from '../../../../node_modules/tiny-slider/src/tiny-slider'

export default class SittersCarousel {
    static get selectors() {
        return {
            main: '.b-sitters-carousel',
            slider: '.b-sitters-carousel__slider',
            slide: '.b-sitters-carousel__slide',
            btnPrev: '.b-sitters-carousel__arrow_prev',
            btnNext: '.b-sitters-carousel__arrow_next',
            sliderPageCurrent: '.b-sitters-carousel__page-value_current',
            sliderPageTotal: '.b-sitters-carousel__page-value_total',
            tnsActive: '.tns-slide-active',
        }
    }

    static get classes() {
        return {
            slideCenter: 'b-sitters-carousel__slide_center',
            slidePrev: 'b-sitters-carousel__slide_prev',
            slideNext: 'b-sitters-carousel__slide_next',
        }
    }

    static init($context = $(document), options) {
        $(SittersCarousel.selectors.main, $context).each( (i, elem) => {
            const $elem = $(elem);

            if(!$elem.hasClass('js-init')) return;
            if($elem.data('block-api')) return;

            new SittersCarousel($elem, options);
        })
    }

    constructor($elem, options) {
        this.params = $.extend({
            selectors: SittersCarousel.selectors,
            classes: SittersCarousel.classes
        }, options);

        this.styleCenterPlate = this.styleCenterPlate.bind(this);

        this.elems = {
            $main: $elem,
            $slider: $elem.find(this.params.selectors.slider),
            $slide: $elem.find(this.params.selectors.slide),
            $btnPrev: $elem.find(this.params.selectors.btnPrev),
            $btnNext: $elem.find(this.params.selectors.btnNext),
            $sliderPageCurrent: $elem.find(this.params.selectors.sliderPageCurrent),
            $sliderPageTotal: $elem.find(this.params.selectors.sliderPageTotal),
        };

        this.renderPagination();

        const inlineSliderOptions = this.elems.$main.data('slider-options') || {};

        const sliderDefaults = {
            container: this.elems.$slider.get(0),
            items: 1,
            controls: false,
            center: true,
            speed: 500,
            onInit: this.styleCenterPlate,
            responsive: {
                320: {
                    fixedWidth: 320
                },
                500: {
                    fixedWidth: 460,
                },
                768: {
                    fixedWidth: 748,
                },
                1024:{
                    fixedWidth: 910
                },
                1280: {
                    fixedWidth: 1128
                }
            }
        }


        this.slider = tns({
            ...inlineSliderOptions,
            ...sliderDefaults
        })

        this.handleChangeBtnClick();
        this.handleindexChange();
        this.handleTransitionStart();
    }

    renderPagination() {
        this.elems.$slide.each( (i, elem) => {
            $(elem).find(this.elems.$sliderPageCurrent).text(i+1);
            $(elem).find(this.elems.$sliderPageTotal).text(this.elems.$slide.length)
        })
    }

    styleCenterPlate() {
        const $activeSlides = this.elems.$main.find(this.params.selectors.tnsActive);
        this.elems.$main.find('.tns-item')
            .removeClass(this.params.classes.slideCenter)
            .removeClass(this.params.classes.slidePrev)
            .removeClass(this.params.classes.slideNext);

        if($activeSlides.length !== 1){
            $activeSlides.eq(1).addClass(this.params.classes.slideCenter);
            $activeSlides.eq(0).addClass(this.params.classes.slidePrev);
            $activeSlides.eq(2).addClass(this.params.classes.slideNext);
        } else {
            $activeSlides.eq(0).addClass(this.params.classes.slideCenter);
        }

    }

    handleChangeBtnClick() {
        this.elems.$btnNext.on('click', () => {
            this.slider.goTo('next');
        });
        this.elems.$btnPrev.on('click', () => {
            this.slider.goTo('prev');
        })


    }

    handleindexChange() {
        this.slider.events.on('indexChanged', () => {
            this.elems.$btnNext.off('click');
            this.elems.$btnPrev.off('click');

            this.elems.$btnPrev = this.elems.$main.find(this.params.selectors.btnPrev);
            this.elems.$btnNext = this.elems.$main.find(this.params.selectors.btnNext);

            this.handleChangeBtnClick();
        })
    }

    handleTransitionStart() {
        this.slider.events.on('transitionEnd', () => {
            this.styleCenterPlate();
        })
    }

}